{
  "fr": {
    "form": {
      "actions": {
        "cancel": "Annuler",
        "clear": "Effacer",
        "closeFullPage": "Fermer la page",
        "copyText": "Cliquez pour copier le texte",
        "create_and_attach_phase": "Créer et associer à la phase",
        "create_and_send": "Créer et envoyer",
        "create_and_send_to_customer": "Créer et envoyer au client",
        "create_and_share": "Créer et partager avec le client",
        "create_and_share_partners_only": "Créer et partager avec les partenaires",
        "create_and_share_with_partners": "Créer et partager avec le client et les partenaires",
        "next": "Suivant",
        "only_create": "Créer uniquement",
        "openFullPage": "Ouvrir en pleine page",
        "save": "Sauvegardez",
        "saveChanges": "Sauvegardez les modifications",
        "save_as_draft": "Enregistrer comme brouillon",
        "search": "Rechercher...",
        "send": "Envoyer",
        "send_and_create_another": "Envoyer et créer un autre",
        "send_to_customer": "Envoyer au client",
        "share_with_customer": "Partager avec le client",
        "submit": "Envoyer",
        "submit_and_create_another": "Soumettre et créer un autre"
      },
      "back": "Etape précédente",
      "labels": {
        "columns": "Colonnes",
        "from": "Du",
        "no_results": "Pas de résultats",
        "optional": "(facultatif)",
        "to": "Au"
      },
      "notifications": {
        "textHasBeenCopied": "Le texte a été copié"
      },
      "password": "Mot de passe",
      "send_moment": {
        "attach_failed": "Créé, mais pas associé à la phase. Associez-le à nouveau dans le workflow.",
        "concept_description": "Personne ne voit rien. Vous l'envoyez vous-même plus tard, ou vous l'associez quand même à une phase.",
        "concept_title": "Enregistrer comme brouillon",
        "item_decision": "cette décision",
        "item_survey": "cette enquête",
        "item_todo": "cette tâche",
        "now_description_decision": "Les clients des unités sélectionnées reçoivent la décision tout de suite, avec une notification.",
        "now_description_survey": "Les clients des unités sélectionnées reçoivent l'enquête tout de suite, avec une notification.",
        "now_description_todo": "Les personnes assignées des unités sélectionnées reçoivent la tâche tout de suite, avec une notification.",
        "now_title": "Envoyer maintenant",
        "phase_description": "Part automatiquement pour chaque unité dès qu'elle atteint la phase.",
        "phase_label": "Phase",
        "phase_title": "Associer à une phase",
        "title": "Quand le client verra-t-il {item} ?",
        "workflow_help": "Qu'est-ce qu'un workflow ?",
        "workflow_help_more": "En savoir plus",
        "workflow_help_text": "Un workflow, ce sont les phases que chaque unité traverse. Si vous associez un élément à une phase, le client le voit automatiquement dès que son unité atteint cette phase."
      },
      "shortcuts": {
        "save_mac": "⌘ + Entrée pour sauvegarder",
        "save_windows": "Ctrl + Entrée pour enregistrer",
        "send_mac": "⌘ + Entrée pour envoyer",
        "send_windows": "Ctrl + Entrée pour envoyer"
      },
      "steps": "Etape {count} sur {total}",
      "writeEmployeeNameReject": "Noter <i><b>{employeeName}</b></i> pour terminer la suppression."
    }
  }
}
